// src/views/admin/clients/index.jsx
import { useToast, Button } from '@chakra-ui/react';
import AdminPageShell from '../../../components/layout/AdminPageShell';
import { columnsDataClients } from './variables/columnsDataProviders.js';
import React, { useEffect, useState } from 'react';
import { getData, postData, putData } from '../../../utils/httpClient.js';
import { useSearch } from '../../../contexts/SearchContext.js';
import ProvidersEditModal from '../../../components/Providers/ProvidersEditModal.js';
import ProvidersTable from 'components/Providers/ProvidersTable.js';
import { useResetPageOnFilterChange } from '../../../hooks/useResetPageOnFilterChange.js';
import { useTableSorting } from '../../../hooks/useTableSorting.js';

export default function Settings() {
  const { searchQuery, resetListFilters } = useSearch(); 
  const [data, setData] = useState([]); 
  const [page, setPage] = useState(0); 
  const [totalPages, setTotalPages] = useState(0); 
  const [modalState, setModalState] = useState({ isOpen: false, provider: null, isNew: false });
  const [rowsPerPage, setRowsPerPage] = useState(10); 
  const toast = useToast();
  const { sorting, setSorting, sortBy, sortDir } = useTableSorting();

  useResetPageOnFilterChange(setPage, page, [searchQuery, rowsPerPage, sortBy, sortDir]);

  const loadData = async (dato) => {
    try {
      const response = await getData(`/providers?page=${page + 1}&limit=${rowsPerPage}&data=${dato}`);
      setData(response?.payload?.providers || []); // Actualiza los datos
      setTotalPages(Math.ceil(response?.payload?.total / rowsPerPage));
    } catch (error) {
      toast({
        title: 'Error al obtener proveedores',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    loadData(searchQuery);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, searchQuery, rowsPerPage]);

  useEffect(() => {
    resetListFilters();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const openNewProviderModal = () => {
    setModalState({ isOpen: true, provider: { id: null, name: '' }, isNew: true });
  };

  const closeEditModal = () => {
    setModalState({ isOpen: false, provider: null, isNew: false });
  };

  const handleCreateProvider = async (newProvider) => {
    try {
      await postData('/providers', newProvider);
      loadData(searchQuery);
      closeEditModal(); 
    } catch (error) {
      toast({
        title: 'Error al crear proveedor',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleUpdateProvider = async (provider) => {
    try {
      await putData(`/providers/${provider.id}`, provider);
      await loadData(searchQuery); 
      closeEditModal(); 
    } catch (error) {
      toast({
        title: 'Error al actualizar el proveedor',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <AdminPageShell
      title="Proveedores"
      actions={
        <Button variant="adminPrimary" size="sm" onClick={openNewProviderModal}>
          Nuevo proveedor
        </Button>
      }
    >
      <ProvidersTable
          columnsData={columnsDataClients}
          data={data} 
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          pageSize={rowsPerPage}
          setPageSize={setRowsPerPage}
          handleUpdateProvider={handleUpdateProvider}
          sorting={sorting}
          onSortingChange={setSorting}
        />

      <ProvidersEditModal
        isOpen={modalState.isOpen}
        onClose={closeEditModal}
        provider={modalState.provider}
        isNew={modalState.isNew}
        onCreate={handleCreateProvider} 
      />
    </AdminPageShell>
  );
}
